import { CircularProgress, ListItemIcon, ListItemText, MenuItem, useTheme } from "@mui/material";
import { MdsThumbUp } from "@sinch/icons";
import { enqueueSnackbar } from "notistack";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useApplicantStatus } from "@sinch/components/application/Applicant/useApplicantStatus";
import { useAttendanceUpdate } from "@sinch/components/application/Attendace/AttendanceUpdateProvider";

interface ApplicantApproveMenuItemProps {
  loading: boolean;
  handleClose: () => void;
  applicantId: string;
  onLoading?: (loading: boolean) => void;
}

export const ApplicantApproveMenuItem: FC<ApplicantApproveMenuItemProps> = ({
  loading,
  handleClose,
  applicantId,
  onLoading,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { approveApplicant } = useApplicantStatus();
  const trigger = useAttendanceUpdate();

  const handleKick = async () => {
    onLoading?.(true);
    try {
      const response = await approveApplicant(applicantId, true);
      if (response?.payload) {
        trigger?.([
          {
            positionId: response.payload.position.id,
            shiftId: response.payload.position.shift.id,
            workerId: response.payload.worker.id,
          },
        ]);
      }
    } catch (e) {
      console.error(e);
      enqueueSnackbar(t("Error.anErrorHasOccurred"), { variant: "error" });
    }
    onLoading?.(false);
    handleClose();
  };

  return (
    <MenuItem disabled={loading} onClick={handleKick} sx={({ palette }) => ({ color: palette.success.main })}>
      <ListItemIcon>
        {loading ? (
          <CircularProgress color="success" size={16} thickness={5} />
        ) : (
          <MdsIcon color="success" fontSize="small" icon={MdsThumbUp} sx={{ minWidth: "36px" }} />
        )}
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ color: theme.palette.success.main }}>{t("approve")}</ListItemText>
    </MenuItem>
  );
};
